<p-popover #op (onHide)="onPopoverHide()">
  <div class="w-[509px] max-w-[90vw] h-[452px] flex flex-col">
    <!-- Header (fijo) -->
    <div class="px-4 pt-3 pb-2 shrink-0">
      <p class="m-0 qbrain-text-lg qbrain-text-primary font-semibold">
        Notificaciones
      </p>
    </div>

    <p-tabs
      [value]="selectedTab()"
      (valueChange)="setSelectedTab($event)"
      class="flex-1 flex flex-col linked-tabs min-h-0"
    >
      <p-tablist class="w-full px-2">
        <p-tab value="0" class="flex items-center !gap-2 !h-10">
          <span class="qbrain-text-sm font-semibold qbrain-text-primary">Generales</span>
          <span
            class="inline-flex items-center justify-center min-w-[16px] h-[16px] px-1
                   rounded-full bg-[var(--cta-bg-primary-solid)] text-white text-[11px] font-bold leading-none"
          >
            {{ totalRecords() }}
          </span>
        </p-tab>
        <p-tab value="1" class="flex items-center !gap-2 !h-10">
          <span class="qbrain-text-sm font-semibold qbrain-text-primary">Novedades</span>
          <span
            class="inline-flex items-center justify-center min-w-[16px] h-[16px] px-1
                   rounded-full bg-[var(--cta-bg-primary-solid)] text-white text-[11px] font-bold leading-none"
          >
            {{ news().length }}
          </span>
        </p-tab>
      </p-tablist>

      <p-tabpanels class="flex-1 overflow-hidden min-h-0">
        <!-- ====== GENERALES: contenido real existente, sin cambios funcionales ====== -->
        <p-tabpanel value="0" class="h-full min-h-0">
          <div class="flex flex-col h-full min-h-0">
            @if (initialLoading()) {
              <!-- ====== CARGA INICIAL: SKELETON ====== -->
              <div class="flex-1 overflow-auto px-2 pb-2 min-h-0">
                <ul class="list-none m-0 p-0 flex flex-col gap-2">
                  @for (s of skeletonRows(); track $index) {
                    <li class="flex gap-4 p-2 rounded-[8px] items-center">
                      <p-skeleton shape="circle" size="2.25rem"></p-skeleton>
                      <div class="flex-1 min-w-0 space-y-2">
                        <p-skeleton width="40%" height="0.75rem"></p-skeleton>
                        <p-skeleton width="90%" height="1rem"></p-skeleton>
                        <p-skeleton width="70%" height="1rem"></p-skeleton>
                      </div>
                    </li>
                  }
                </ul>
              </div>
            } @else if (notifications().length === 0) {
              <!-- ====== ESTADO VACÍO ====== -->
              <div class="flex-1 flex flex-col items-center justify-center gap-4 px-6 py-6 min-h-0">
                <img
                  src="assets/img/no-data.svg"
                  alt="Sin notificaciones"
                  class="block w-[150px] h-[128px] object-contain"
                />
                <p class="qbrain-text-sm qbrain-text-tertiary font-bold text-center">
                  No hay notificaciones pendientes
                </p>
              </div>
            } @else {
            <!-- Body (scrollea) -->
            <div #scrollRoot class="flex-1 overflow-auto px-2 pb-2 min-h-0">
              <ul class="list-none m-0 p-0 flex flex-col gap-2">
                <!-- Solicitud de acceso (Sin leer) -->
                @for (item of notifications(); track item.notificationID) {
                  @if (item.notificationType === APPROVAL_ASSOCIATION) {
                    <li
                      class="flex gap-4 p-2 rounded-[8px]"
                      [class.bg-[var(--cta-bg-soft-primary)]]="item.decision === null"
                      [class.hover:bg-[var(--bg-surface-hover)]]="item.decision !== null"
                    >
                      <div
                        class="shrink-0 w-9 h-9 rounded-full border border-[var(--border-default)]
                               bg-[var(--cta-bg-soft-primary)] flex items-center justify-center"
                      >
                        <img src="assets/icons/warning-alert.svg" alt="icon" class="w-5 h-5" />
                      </div>
                      <div class="relative flex-1 min-w-0 flex flex-col gap-1">
                        <span class="qbrain-text-xs qbrain-text-tertiary">
                          {{ item.date | date: 'dd MMM. yyyy hh:mm a' }}
                        </span>
                        <div class="qbrain-text-sm qbrain-text-secondary leading-[18px]">
                          <span class="qbrain-text-primary font-semibold">Tienes nuevas solicitudes de acceso a tus documentos.</span>
                          <br />
                          <span class="qbrain-text-primary font-semibold">Aprueba o rechaza</span>
                          desde el
                          <a class="text-[var(--text-link)] font-semibold cursor-pointer" (click)="goToPanelNotification()">
                            Panel de solicitudes.
                          </a>
                        </div>
                        @if (item.decision === null) {
                          <span class="absolute top-0 right-0 w-[10px] h-[10px] rounded-full bg-[var(--cta-bg-primary-solid)]"></span>
                        }
                      </div>
                    </li>
                } @else if (item.notificationType === JOINED_WORKSPACE) {
                    <li
                      class="flex gap-4 p-2 rounded-[8px]"
                      [class.bg-[var(--cta-bg-soft-primary)]]="item.decision === null"
                      [class.hover:bg-[var(--bg-surface-hover)]]="item.decision !== null"
                    >
                      <div
                        class="shrink-0 w-9 h-9 rounded-full border border-[var(--border-default)]
                               bg-[var(--cta-bg-soft-primary)] flex items-center justify-center"
                      >
                        <img src="assets/icons/login-box-line.svg" alt="icon" class="w-5 h-5" />
                      </div>
                      <div class="relative flex-1 min-w-0 flex flex-col gap-1">
                        <span class="qbrain-text-xs qbrain-text-tertiary">
                          {{ item.date | date: 'dd MMM. yyyy hh:mm a' }}
                        </span>
                        <div class="qbrain-text-sm qbrain-text-primary leading-[18px]">
                          <span class="font-semibold">{{ item.data.user }}</span>
                          <span> te dió acceso al espacio de trabajo: </span>
                          <span class="text-[var(--text-link)] font-semibold">{{ item.data.workspace }}</span>
                        </div>
                      </div>
                    </li>
                } @else if (item.notificationType === APPROVAL_DOCUMENT) {
                    <li
                      class="flex gap-4 p-2 rounded-[8px]"
                      [class.bg-[var(--cta-bg-soft-primary)]]="item.decision === null"
                      [class.hover:bg-[var(--bg-surface-hover)]]="item.decision !== null"
                    >
                      <div
                        class="shrink-0 w-9 h-9 rounded-full border border-[var(--border-default)]
                               bg-[var(--cta-bg-soft-primary)] flex items-center justify-center"
                      >
                        <img src="assets/icons/warning-alert.svg" alt="icon" class="w-5 h-5" />
                      </div>
                      <div class="relative flex-1 min-w-0 flex flex-col gap-1">
                        <span class="qbrain-text-xs qbrain-text-tertiary">
                          {{ item.date | date: 'dd MMM. yyyy hh:mm a' }}
                        </span>
                        <div class="qbrain-text-sm qbrain-text-primary leading-[18px]">
                          <span>Tu solicitud de </span>
                          <span class="font-semibold">acceso a documentos fue respondida.</span>
                          <br>
                          <span>Revisa el estado de los documentos.</span>
                        </div>
                      </div>
                    </li>
                } @else if (item.notificationType === STALE_DOCUMENT) {
                    <li
                      class="flex gap-4 p-2 rounded-[8px]"
                      [class.bg-[var(--cta-bg-soft-primary)]]="item.read === false"
                      [class.hover:bg-[var(--bg-surface-hover)]]="item.read !== false"
                    >
                      <div
                        class="shrink-0 w-9 h-9 rounded-full border border-[var(--border-default)]
                               bg-[var(--cta-bg-soft-primary)] flex items-center justify-center"
                      >
                        <img src="assets/icons/upload-file.svg" alt="icon" class="w-5 h-5" />
                      </div>
                      <div class="relative flex-1 min-w-0 flex flex-col gap-1">
                        <span class="qbrain-text-xs qbrain-text-tertiary">
                          {{ item.date | date: 'dd MMM. yyyy hh:mm a' }}
                        </span>
                        <div class="qbrain-text-sm qbrain-text-primary leading-[18px]">
                          <span>El documento </span>
                          <span class="font-semibold">{{ item.data.DocumentName }}</span>
                          <span> no han sido consultados en los últimos 3 meses.</span>
                        </div>
                        @if (item.read === false) {
                          <span class="absolute top-0 right-0 w-[10px] h-[10px] rounded-full bg-[var(--cta-bg-primary-solid)]"></span>
                        }
                      </div>
                    </li>
                } @else if (item.notificationType === REPLACE_DOCUMENT) {
                    <li
                      class="flex gap-4 p-2 rounded-[8px]"
                      [class.bg-[var(--cta-bg-soft-primary)]]="item.read === false"
                      [class.hover:bg-[var(--bg-surface-hover)]]="item.read !== false"
                    >
                      <div
                        class="shrink-0 w-9 h-9 rounded-full border border-[var(--border-default)]
                               bg-[var(--cta-bg-soft-primary)] flex items-center justify-center"
                      >
                        <img src="assets/icons/hourglass-empty.svg" alt="icon" class="w-5 h-5" />
                      </div>
                      <div class="relative flex-1 min-w-0 flex flex-col gap-1">
                        <span class="qbrain-text-xs qbrain-text-tertiary">
                          {{ item.date | date: 'dd MMM. yyyy hh:mm a' }}
                        </span>
                        <div class="qbrain-text-sm qbrain-text-primary leading-[18px]">
                          <span>El documento </span>
                          <span class="font-semibold">{{ item.data.old_doc }}</span>
                          <span> fue reemplazado por una nueva versión.</span>
                        </div>
                        @if (item.read === false) {
                          <span class="absolute top-0 right-0 w-[10px] h-[10px] rounded-full bg-[var(--cta-bg-primary-solid)]"></span>
                        }
                      </div>
                    </li>
                }
                }
              </ul>

              @if (loadingMore()) {
                <ul class="list-none m-0 p-0 flex flex-col gap-2 mt-2">
                  @for (s of skeletonRows(); track $index) {
                    <li class="flex gap-4 p-2 rounded-[8px] items-center">
                      <p-skeleton shape="circle" size="2.25rem"></p-skeleton>
                      <div class="flex-1 min-w-0 space-y-2">
                        <p-skeleton width="40%" height="0.75rem"></p-skeleton>
                        <p-skeleton width="90%" height="1rem"></p-skeleton>
                        <p-skeleton width="70%" height="1rem"></p-skeleton>
                      </div>
                    </li>
                  }
                </ul>
              }

              <div
                appInfiniteScroll
                (reachedEnd)="loadMore()"
                [disabled]="loading() || !hasMore()"
                class="h-1 pt-4">
              </div>
            </div>
            }
          </div>
        </p-tabpanel>

        <!-- ====== NOVEDADES: listado mock estático ====== -->
        <p-tabpanel value="1" class="h-full min-h-0">
          <div class="flex flex-col h-full min-h-0">
            <div class="flex-1 overflow-auto px-2 pb-2 min-h-0">
              <ul class="list-none m-0 p-0 flex flex-col gap-2">
                @for (n of news(); track n.id) {
                  <li
                    class="flex gap-4 p-2 rounded-[8px]"
                    [class.bg-[var(--cta-bg-soft-primary)]]="n.unread"
                    [class.hover:bg-[var(--bg-surface-hover)]]="!n.unread"
                  >
                    <div
                      class="shrink-0 w-9 h-9 rounded-full border border-[var(--border-default)]
                             bg-[var(--cta-bg-soft-primary)] flex items-center justify-center"
                    >
                      <img src="assets/icons/flash.svg" alt="icon" class="w-5 h-5" />
                    </div>
                    <div class="relative flex-1 min-w-0 flex flex-col gap-1">
                      <span class="qbrain-text-xs qbrain-text-tertiary">
                        {{ n.date | date: 'dd MMM. yyyy hh:mm a' }}
                      </span>
                      <div class="qbrain-text-sm qbrain-text-primary leading-[18px]">
                        <p class="m-0 font-semibold">{{ n.title }}</p>
                        <p class="m-0">
                          <span>{{ n.body }}</span>
                          @if (n.ctaLabel) {
                            <a class="text-[var(--text-link)] font-semibold cursor-pointer ml-1">{{ n.ctaLabel }}</a>
                          }
                        </p>
                      </div>
                      @if (n.unread) {
                        <span class="absolute top-0 right-0 w-[10px] h-[10px] rounded-full bg-[var(--cta-bg-primary-solid)]"></span>
                      }
                    </div>
                  </li>
                }
              </ul>
            </div>
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</p-popover>
